const MAY_ACT_AS = {
    founder: ['ops_ad', 'ops_member', 'sales', 'marketing'],
    ops_ad: ['ops_member', 'sales', 'marketing'],
};
export const ACT_AS_MINUTES = 30;
/** How a refusal names a role: "You cannot act as the founder", "…the capture link of the associate director". */
export const ROLE_RANK_LABEL = {
    founder: 'the founder', ops_ad: 'the associate director', ops_member: 'an Ops member', sales: 'Sales', marketing: 'Marketing', hr: 'HR',
};
export function mayActAs(real, target) {
    return (MAY_ACT_AS[real] ?? []).includes(target);
}
/**
 * Someone else's password (reset or remove) follows the act-as ladder: a temporary password lets you sign in as
 * them, so you may only do it to someone you may act as (sf-b226aae7). The founder is the backstop: a founder may
 * also manage another founder's or HR's password, because that is their only in-app recovery path. Never your own
 * (that is POST /auth/password/change), checked separately. Enforced again in Postgres
 * (db/policies/0078_password_manage_ladder.sql password_guard_target).
 */
export function mayManagePassword(real, target) {
    return real === 'founder' || mayActAs(real, target);
}
/**
 * Nothing irreversible, financial or identity-changing happens under a borrowed identity (ADR-006 §4.2).
 * Code-level refusals cover the rest: filing a timesheet, electing an optional holiday, rotating a capture
 * link, connecting a Google account (all personal declarations or credentials).
 *
 * `client.changeSpoc` is NOT on this list (operator ruling 16 Oct 2026: "Founder can change SPOCs and reassign
 * directly"). Only the founder and the AD hold it and only the founder may act as the AD, so this lets exactly the
 * founder-acting-as-AD change a SPOC; the audit rows carry actor = the founder, on_behalf_of = the AD.
 */
export const DENY_WHILE_ACTING = [
    'settings.write',
    'settings.system',
    'holidays.manage',
    'users.write',
    'timesheet.file',
    'actAs.member',
];
/** Effective capabilities while acting: the target's, minus the deny list. */
export function actingCapabilities(targetCaps) {
    return targetCaps.filter((c) => !DENY_WHILE_ACTING.includes(c));
}
//# sourceMappingURL=actas.js.map